import React, { Component } from 'react';

class Calendar extends Component {
    constructor(props) {
        super(props);
        this.iframe = null;
        this.state = {
            iframeHeight: 390,
            iframeWidth: '355px'
        };
    }

    setIframeRef(element) {
        this.iframe = element;
    }



    componentDidMount() {
        if (this.iframe && this.iframe.contentWindow) {
            this.injectThemeVariables();
            this.calculateIframeDimensions();
        }
    }


    componentDidUpdate(prevProps) {
        // Only update if themeStyles changed
        if (prevProps.themeStyles !== this.props.themeStyles) {
            this.injectThemeVariables();
            this.calculateIframeDimensions();
        }
    }

    // Convert rem/spacing values to pixels for calculation
    convertSpacingToPixels = (spacingValue) => {
        if (!spacingValue) return 0;

        // Remove 'rem' and convert to number
        const remValue = parseFloat(spacingValue.replace('rem', ''));
        // Assuming 1rem = 16px (standard browser default)
        return remValue * 16;
    }

    // Calculate dynamic iframe dimensions based on spacing
    calculateIframeDimensions = () => {
        const theme = this.props.themeStyles || {};
        const spacing = theme['--spacing'] || '0.25rem';

        // Convert spacing to pixels
        const spacingPx = this.convertSpacingToPixels(spacing);

        // Base dimensions - your specified base values
        const baseHeight = 330;
        const baseWidth = 300;

        // Calculate scaling factor based on spacing (max 0.35rem = 5.6px)
        const maxSpacingPx = 5.6; // 0.35rem * 16px
        const scaleFactor = 1 + (spacingPx / maxSpacingPx) * 0.5; // Scale up to 50% more at max spacing

        const newHeight = Math.round(baseHeight * scaleFactor);
        const newWidth = Math.round(baseWidth * scaleFactor);
        const finalHeight = newHeight;
        const finalWidth = `${newWidth}px`;

        this.setState({
            iframeHeight: finalHeight,
            iframeWidth: finalWidth
        });
    }


    injectThemeVariables = () => {
        if (this.iframe && this.iframe.contentWindow) {
            const root = this.iframe.contentWindow.document.documentElement;
            const theme = this.props.themeStyles;

            Object.entries(theme).forEach(([key, value]) => {
                root.style.setProperty(key, value);
            });

            // Set dynamic iframe styling to prevent scrollbars
            const iframeDocument = this.iframe.contentWindow.document;
            if (iframeDocument.body) {
                iframeDocument.body.style.margin = '0';
                iframeDocument.body.style.padding = '10px';
                iframeDocument.body.style.overflow = 'hidden';
                iframeDocument.documentElement.style.overflow = 'hidden';
            }
        }
    };


    render() {
        const { iframeHeight, iframeWidth } = this.state;

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <iframe
                    onLoad={this.injectThemeVariables}
                    ref={(el) => this.setIframeRef(el)}
                    src="/public/calendar.html"
                    style={{
                        minHeight: `${iframeHeight}px`,
                        height: `${iframeHeight}px`,
                        width: iframeWidth,
                        border: 'none',
                        overflow: 'hidden'
                    }}
                />
            </div>
        );
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/Calendar.js